import { render, staticRenderFns } from "./CookieChoice.vue?vue&type=template&id=e21dc01e&scoped=true"
import script from "./CookieChoice.vue?vue&type=script&lang=js"
export * from "./CookieChoice.vue?vue&type=script&lang=js"
import style0 from "./CookieChoice.vue?vue&type=style&index=0&id=e21dc01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21dc01e",
  null
  
)

export default component.exports